import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { UserRepository } from "@user/data/repositories/user.repository";
import { inject, injectable } from "inversify";

@injectable()
export class DeleteUserUseCase {
    constructor(
        @inject(UserRepository)
        private readonly userRepository: UserRepository,
    ) {}

    async execute(userId: number): Promise<boolean> {
        const result = await this.userRepository.delete(userId);

        if (result.isLeft()) {
            ToastManagerStore.error(result.getLeftOrThrow().message);
            return false;
        }

        ToastManagerStore.success();
        return true;
    }
}
